"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildHTMLTags = buildHTMLTags;
exports.getAbsoluteCDNUrl = getAbsoluteCDNUrl;
exports.parseDataCenterFromXpdManifestName = parseDataCenterFromXpdManifestName;
var _url = _interopRequireDefault(require("url"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Takes a nui config and returns the absolute CDN Url
 * @param   {object} config nui config object
 * @returns {string} The absolute CDN url
 */
function getAbsoluteCDNUrl(config) {
  var cdn = config.nui.assets.cdn.url;
  return "https:".concat(cdn);
}

// eslint-disable-next-line default-param-last
function getSRIAttr() {
  var hashes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var asset = arguments.length > 1 ? arguments[1] : undefined;
  if (!hashes[asset]) return '';
  return " crossorigin=\"anonymous\" integrity=\"".concat(hashes[asset], "\"");
}
function getScriptAttr(options) {
  var _options$js;
  var _ref = (_options$js = options === null || options === void 0 ? void 0 : options.js) !== null && _options$js !== void 0 ? _options$js : {},
    defer = _ref.defer,
    id = _ref.id;
  var idAttribute = id ? " id=\"".concat(String(id), "\"") : '';
  return "".concat(idAttribute).concat(defer ? ' defer' : '');
}

// Construct HTML tags from object of assets
// assets = {js: [...], css: [...]}
function buildHTMLTags(config) {
  var xpdConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var cdn = config.nui.assets.cdn.url;
  var _xpdConfig$files = xpdConfig.files,
    files = _xpdConfig$files === void 0 ? {} : _xpdConfig$files,
    _xpdConfig$integrityH = xpdConfig.integrityHash,
    integrityHash = _xpdConfig$integrityH === void 0 ? {} : _xpdConfig$integrityH;
  var _files$js = files.js,
    js = _files$js === void 0 ? [] : _files$js,
    _files$css = files.css,
    css = _files$css === void 0 ? [] : _files$css;
  var _integrityHash$js = integrityHash.js,
    jsHash = _integrityHash$js === void 0 ? {} : _integrityHash$js,
    _integrityHash$css = integrityHash.css,
    cssHash = _integrityHash$css === void 0 ? {} : _integrityHash$css;
  var jsFiles = (0, _isFunction.default)(options === null || options === void 0 ? void 0 : options.jsFilterFn) ? js.filter(options === null || options === void 0 ? void 0 : options.jsFilterFn) : js;
  var cssFiles = (0, _isFunction.default)(options === null || options === void 0 ? void 0 : options.cssFilterFn) ? css.filter(options === null || options === void 0 ? void 0 : options.cssFilterFn) : css;
  var jsTags = jsFiles.map(function (asset) {
    return "<script data-xpd".concat(getScriptAttr(options)).concat(getSRIAttr(jsHash, asset), " src=\"").concat(_url.default.resolve(cdn, asset), "\"></script>");
  });
  var cssTags = cssFiles.map(function (asset) {
    return "<link data-xpd".concat(getSRIAttr(cssHash, asset), " rel=\"stylesheet\" type=\"text/css\" href=\"").concat(_url.default.resolve(cdn, asset), "\" />");
  });
  return [].concat(_toConsumableArray(jsTags), _toConsumableArray(cssTags)).join('\r\n');
}
function parseDataCenterFromXpdManifestName(config) {
  var _ref2 = (config === null || config === void 0 ? void 0 : config.crossPlatformDelivery) || {},
    url = _ref2.url;
  if (!url) return '';
  var startToken = 'manifest-';
  var endToken = '.json';
  var startPos = url.indexOf(startToken);
  var endPos = url.indexOf(endToken);
  if (startPos === -1 || endPos === -1) return '';
  return url.substring(startPos + startToken.length, endPos);
}